import { render, staticRenderFns } from "./ChildrenInfoTable.vue?vue&type=template&id=11d9f583"
import script from "./ChildrenInfoTable.vue?vue&type=script&lang=js"
export * from "./ChildrenInfoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports